var exports = {
  "k": "x127c5a35--8e19b1--container",
  "U": "x127c5a35--8e19b1--buttons",
};

module.exports = exports;
